var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',[_c('Titulo',{attrs:{"titulo":'Novo cliente'}})],1)],1),_c('v-row',[_c('v-col',{attrs:{"lg":"6"}},[_c('v-card',{class:'rounded-xl ' + (_vm.isMobile ? 'pa-3' : 'pa-6'),attrs:{"outlined":""}},[_c('v-card-text',[_c('FormCliente',{on:{"on-submit":_vm.grava}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }